import './applied_grouped_elements_view.js.coffee'

Namespace 'Common.Dashboard.Filters'

FILTERS = Common.Dashboard.Filters

class Common.Dashboard.Filters.AppliedSecondaryGroupedElementsView extends FILTERS.AppliedGroupedElementsView

  initialize: ({filter, isReadOnly}) ->
    super({filter, titleClassName: 'label-success', isReadOnly})
    @values = filter.getValues()?.included?.secondary?.values || []

  _displayTitle: ->
    'AND'

  _displayValues: ->
    @_mapValues(@filter.getValues()?.included?.secondary?.values || [])
